import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {onlineUsers, onlineUserTokens, onlineUserCountStats, onlineUserTokenKick, onlineUserKick, onlineUserKickExcludeOneself} = api


/**
 * 查找登录用户数(唯一:用户id)
 */
export async function findOnlineUserCountStats(params) {
    return request({url: onlineUserCountStats, method: 'get', data: params,})
}

/**
 * 查找在线用户列表(唯一:用户id)
 */
export async function findOnlineUsers(params) {
    return request({url: onlineUsers, method: 'get', data: params,})
}

/**
 * 查找在线用户
 */
export async function findOnlineUserTokens(params) {
    return request({url: onlineUserTokens, method: 'get', data: params,})
}

/**
 * 踢出
 */
export async function kickOnlineUser(params) {
    return request({url: onlineUserKick, method: 'post', data: params,})
}

export async function kickOnlineUserToken(params) {
    return request({url: onlineUserTokenKick, method: 'post', data: params,})
}

export async function kickOnlineUserExcludeOneself() {
    return request({url: onlineUserKickExcludeOneself, method: 'post', data: {},})
}


// WEBPACK FOOTER //
// ./src/services/onlineUser.js